<template>
  <div class="board">
    <InfoBox
      :title="title"
    >
      <Message
        v-for="message in messages"
        :key="message.title"
        :message="message"
      />
    </InfoBox>
  </div>
</template>

<script>
import Message from '@/components/information/sub/Msgone.vue';
import { getHotNotices } from '@/api/notice';
import InfoBox from '@/components/information/sub/InfoBox.vue';

export default {
  components: { Message, InfoBox },
  data() {
    return {
      title: '公告栏',
      messages: null,
    };
  },
  created() {
    getHotNotices().then((data) => {
      this.messages = data;
    });
  },
};
</script>

<style lang="scss" scoped>
.board {
  height: 100%;
}

</style>
